import React from "react";

function LivePause() {
    return (
        <span className="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
                <g fill="none" fillRule="evenodd">
                    <g fill="#FFF">
                        <path d="M723 436c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30-16.569 0-30-13.431-30-30 0-16.569 13.431-30 30-30zm0 5.455c-13.556 0-24.545 10.989-24.545 24.545 0 13.556 10.989 24.545 24.545 24.545 13.556 0 24.545-10.989 24.545-24.545 0-13.556-10.989-24.545-24.545-24.545zm-2.727 10.909v27.272h-5.455v-27.272h5.455zm10.909 0v27.272h-5.455v-27.272h5.455z" transform="translate(-693 -436)" />
                    </g>
                </g>
            </svg>
        </span>
    );
}

export default LivePause;